/**
 * Remote Flash
 * This service allows users to flash a telematics device over the air (FOTA) and retrieve the reported firmware information. 
 *
 * OpenAPI spec version: 0.1.5
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * The flash record's status.
 */
export type FlashStatus = 'queued' | 'downloadedResponsePending' | 'initialDownloadFailed' | 'downloadedSuccessfully' | 'flashedSuccessfully' | 'flashedFailed' | 'autoRetryFailed1' | 'autoRetryFailed2' | 'removedDueToInactivity' | 'firmwareReported';

export const FlashStatus = {
    Queued: 'queued' as FlashStatus,
    DownloadedResponsePending: 'downloadedResponsePending' as FlashStatus,
    InitialDownloadFailed: 'initialDownloadFailed' as FlashStatus,
    DownloadedSuccessfully: 'downloadedSuccessfully' as FlashStatus,
    FlashedSuccessfully: 'flashedSuccessfully' as FlashStatus,
    FlashedFailed: 'flashedFailed' as FlashStatus,
    AutoRetryFailed1: 'autoRetryFailed1' as FlashStatus,
    AutoRetryFailed2: 'autoRetryFailed2' as FlashStatus,
    RemovedDueToInactivity: 'removedDueToInactivity' as FlashStatus,
    FirmwareReported: 'firmwareReported' as FlashStatus
};